import React, { useState, useEffect } from 'react';
import { ModalType } from './types';

import Nav from './components/Nav';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Difference from './components/Difference';
import Founder from './components/Founder';
import Services from './components/Services';
import Method from './components/Method';
import Work from './components/Work';
import Who from './components/Who';
import Clarity from './components/Clarity';
import HowToWork from './components/HowToWork';
import { Insights, FinalCTA, Footer } from './components/BottomSections';
import {
  MarketingModal,
  OperationsModal,
  PackagesModal,
  ProposalModal,
  WorkWithUsModal,
} from './components/Modals';

const App: React.FC = () => {
  const [activeModal, setActiveModal] = useState<ModalType | null>(null);

  const openModal = (type: ModalType) => {
    setActiveModal(type);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setActiveModal(null);
    document.body.style.overflow = '';
  };

  useEffect(() => {
    const els = document.querySelectorAll('.fade-up');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            setTimeout(() => entry.target.classList.add('visible'), i * 80);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div
        className="fixed inset-0 z-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 70% 55% at 12% 18%, rgba(184,154,90,0.038) 0%, transparent 60%), radial-gradient(ellipse 55% 70% at 88% 82%, rgba(184,154,90,0.028) 0%, transparent 58%)',
        }}
      />

      <Nav onOpenModal={openModal} />
      <Hero onOpenModal={openModal} />
      <Problem />
      <Difference />
      <Founder />
      <Services />
      <Method />
      <Work />
      <Clarity onOpenModal={openModal} />
      <Who />
      <HowToWork onOpenModal={openModal} />
      <Insights />
      <FinalCTA onOpenModal={openModal} />
      <Footer onOpenModal={openModal} />

      {activeModal === 'marketing' && <MarketingModal onClose={closeModal} />}
      {activeModal === 'operations' && <OperationsModal onClose={closeModal} />}
      {activeModal === 'packages' && <PackagesModal onClose={closeModal} onOpenModal={openModal} />}
      {activeModal === 'proposal' && <ProposalModal onClose={closeModal} />}
      {activeModal === 'workWithUs' && <WorkWithUsModal onClose={closeModal} />}
    </>
  );
};

export default App;